import { render } from "./ViewDemandePage.vue?vue&type=template&id=50eba610&ts=true"
import script from "./ViewDemandePage.vue?vue&type=script&lang=ts"
export * from "./ViewDemandePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__